import { Card } from './Card';
import { BarChart, IBarChartDataItem } from '@src/components';
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { SimUsage } from '@src/services/dashboard/simUsages/simUsagesApiSliceTypes';
import { InUseSim } from '@src/services/dashboard/inUseSims/inUseSimsApiSliceTypes';
import { useTheme } from '@src/theme';
import { ChartPieIcon, CpuChipIcon } from '@heroicons/react/24/solid';

type MyAccountChartsProps = {
    dataSimUsage: SimUsage[];
    dataInUseSims: InUseSim[];
};
export const MyAccountCharts = ({
    dataSimUsage,
    dataInUseSims,
}: MyAccountChartsProps) => {
    const { theme } = useTheme();
    const dataSimUsageChart: IBarChartDataItem[] = useMemo(() => {
        if (!dataSimUsage) return [];
        const grouped = dataSimUsage.reduce(
            (acc, item) => {
                const day = dayjs(item.date).format('DD MMM');
                if (!acc[day]) {
                    acc[day] = {
                        name: day,
                        value: 0,
                        color: theme.semantic.primary,
                    };
                }
                acc[day].value += item.totalDataUsage;
                return acc;
            },
            {} as Record<string, IBarChartDataItem>
        );
        return Object.values(grouped);
    }, [dataSimUsage]);

    const dataInUseSimsChart: IBarChartDataItem[] = useMemo(() => {
        if (!dataInUseSims) return [];
        const grouped = dataInUseSims.reduce(
            (acc, item) => {
                const day = dayjs(item.date).format('DD MMM');
                if (!acc[day]) {
                    acc[day] = {
                        name: day,
                        value: 0,
                        color: theme.semantic.primary,
                    };
                }
                acc[day].value += item.totalInUse;
                return acc;
            },
            {} as Record<string, IBarChartDataItem>
        );
        return Object.values(grouped);
    }, [dataInUseSims]);

    return (
        <div className="flex flex-col gap-8 my-8 md:flex-row">
            <Card
                title="Data usage"
                className="w-full"
                icon={
                    <ChartPieIcon className="w-6 h-6 text-primary opacity-45" />
                }
                content={
                    <BarChart
                        key="myAccount"
                        name=""
                        data={dataSimUsageChart}
                        height={300}
                        unit="MB"
                    />
                }
            />

            <Card
                title="In-Use"
                className="w-full"
                icon={
                    <CpuChipIcon className="w-6 h-6 text-primary opacity-45" />
                }
                content={
                    <BarChart
                        key="myAccount"
                        name=""
                        data={dataInUseSimsChart}
                        height={300}
                        unit="SIMs"
                    />
                }
            />
        </div>
    );
};
